import { ITEM_TYPES } from 'Utils/index';
import appManager from 'AppManager';
import { shouldHaveContinueWatching } from '../../playerContainerUtils';

/**
 * @param item
 * @returns {Promise<ContinueWatchingItem|null>}
 */
export const checkContinueWatching = async (item) => {
    let match = null;

    if (shouldHaveContinueWatching(item)) {
        try {
            const { items } = await appManager.getApi().fetchContinueWatching();
            if (items && items.length > 0) {
                match = items.find((continueWatchItem) => {
                    if (continueWatchItem?.metaData?.data?.type === 'PVR') {
                        return continueWatchItem?.data?.scheduleId === item.getId();
                    }

                    return continueWatchItem?.data?.id === item.getId();
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    return match ? match.getRawData() : null;
};

export const sendProgressEvent = async (itemType, completedInPercentage, currentTime, itemId) => {
    try {
        const isSchedule = itemType === ITEM_TYPES.TV || itemType === ITEM_TYPES.RECORDING;
        const eventParams = {
            completedInPercentage: String(completedInPercentage),
            stopTimeInMillis: Math.round(currentTime) * 1000
        };

        if (isSchedule) {
            eventParams.scheduleId = String(itemId);
        } else {
            eventParams.movieId = String(itemId);
        }
        appManager.getApi().setEvent({
            created: new Date().toISOString(),
            eventType: isSchedule ? 'CONTINUE_WATCHING_SCHEDULE' : 'CONTINUE_WATCHING_VOD',
            eventParams
        });
    } catch (error) {
        console.log(error);
    }
};

export const sendEndEvent = async (itemType, itemId) => {
    try {
        const isSchedule = itemType === ITEM_TYPES.TV || itemType === ITEM_TYPES.RECORDING;
        const eventParams = {};
        if (isSchedule) {
            eventParams.scheduleId = String(itemId);
        } else {
            eventParams.movieId = String(itemId);
        }
        appManager.getApi().setEvent({
            created: new Date().toISOString(),
            eventType: isSchedule ? 'WATCHED_SCHEDULE' : 'WATCHED_MOVIE',
            eventParams
        });
    } catch (error) {
        console.log(error);
    }
};
